import { create } from 'zustand';

interface CompleteVulModalStore {
  isOpen: boolean;
  vulId: number;
  onCompleteVulClose: () => void;
  onCompleteVulOpen: (vulId: number) => void;
}

export const useCompleteVulModalStore = create<CompleteVulModalStore>(set => ({
  isOpen: false,
  vulId: 0,
  onCompleteVulClose: () => set({ isOpen: false, vulId: 0 }),
  onCompleteVulOpen: (vulId: number) => set({ isOpen: true, vulId }),
}));
